import React from 'react';
import PropTypes from 'prop-types';
import services from 'services/services';
import { Upload, message } from 'antd';

// Import translation
import i18n from 'i18next';

// Import components
import UploadButton from './UploadButton';

export class UploadImage extends React.Component {
	state = {
		uploading: false,
		fileList: []
	};

	handleChange = ({ fileList }) => {
		this.setState({ uploading: true, fileList });
	};

	uploadConfig = (onProgress) => ({
		onUploadProgress: function(progressEvent) {
			const percentCompleted = Math.round(
				(progressEvent.loaded * 100) / progressEvent.total
			);
			onProgress({ percent: percentCompleted });
		}
	});

	handleImageUpload = async ({ file, onSuccess, onError, onProgress }) => {
		try {
			const { modelId, mediaType, successCallback, collectionId } = this.props;

			// Format uploaded file and options
			const formData = new FormData();
			formData.append('file', file);
			formData.append('collection_id', collectionId);
			formData.append('order', 0);

			// Upload image
			const {
				data: { data }
			} = await services.post(
				'/assets/media/create',
				formData,
				this.uploadConfig(onProgress)
			);

			// Attach media to the current model
			await services.post(`/assets/media/${data.id}/attachToModel`, {
				collection_id: collectionId,
				model_id: modelId,
				model_type: mediaType
			});

			// Trigger on success function
			onSuccess(data, data);
			message.success(i18n.t('common:upload_pictures.upload_success'));
			this.setState({ uploading: false, fileList: [] });
			successCallback(data);
		} catch (error) {
			// If there is an error trigger error function
			onError();
			// Check if status is equal to 413 than show message that file is too large
			error.response.status === 413 &&
				message.error(i18n.t('common:upload_pictures.upload_error'));
			error.response.status === 422 &&
				message.error(i18n.t('common:upload_pictures.upload_error'));
		}
	};

	render() {
		const { uploading, fileList } = this.state;

		return (
			<Upload
				listType="picture-card"
				fileList={fileList}
				showUploadList={{ showDownloadIcon: false }}
				onChange={this.handleChange}
				customRequest={this.handleImageUpload}
			>
				{!uploading && <UploadButton />}
			</Upload>
		);
	}
}

UploadImage.defaultProps = {
	modelId: '',
	mediaType: '',
	collectionId: '',
	successCallback: () => {}
};

UploadImage.propTypes = {
	modelId: PropTypes.string.isRequired,
	mediaType: PropTypes.string.isRequired,
	successCallback: PropTypes.func.isRequired,
	collectionId: PropTypes.string
};

export default UploadImage;
